<template>
  <div id="btnProductMenu">
    <v-menu
      v-model="menu"
      offset-x
      min-width="800px"
      close-on-click
      :close-on-content-click="false"
      attach="#btnProductMenu"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          v-on="on"
        >
          Додати Продукт
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <ProductSelect
            v-model="product"
            @input="onSelect"
          />
          <DecimalEditor
            v-model="amount"
            label="Сумма"
            scale="2"
            :hide-details="false"
            class="mt-3"
            :error-messages="$v.amount.$error ? errors.ONLY_POSITIVE : []"
            @input="$v.amount.$touch()"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="selected === null"
            color="primary"
            text
            @click="ok"
          >
            Ок
          </v-btn>
          <v-btn
            text
            @click="menu = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import ProductSelect from "../../catalogs/products/ProductSelect.vue";
import DecimalEditor from "../../../components/DecimalEditor.vue";
import * as productsApi from "../../../backend/productsApi.js";
import { ERRORS } from "@/helpers";
import { minValue } from "vuelidate/lib/validators";

export default {
  components: {
    DecimalEditor,
    ProductSelect,
  },
  data: () => ({
    menu: false,
    selected: null,
    amount: 0,
    product: null,
  }),

  validations: {
    amount: {
      minValue: minValue(0),
    },
  },

  computed: {
    errors() {
      return {
        ONLY_POSITIVE: [ERRORS.ONLY_POSITIVE],
      };
    },
  },
  methods: {
    async onSelect() {
      if (this.product?.id) {
        this.selected = await productsApi.getProduct(this.product.id);
        this.amount = this.selected.amount;
        this.selected.id = this.product.id;
      }
    },
    ok() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      this.$emit("input", {
        id: this.selected.id,
        type: "product",
        title: this.selected.title,
        amount: this.amount,
        article: this.selected.article,
      });
      this.cancel();
    },
    cancel() {
      this.selected = null;
      this.amount = 0;
      this.menu = false;
      this.product = null;
    },
  },
};
</script>
